import { render, staticRenderFns } from "./realName.vue?vue&type=template&id=3d25fe3b&scoped=true"
import script from "./realName.vue?vue&type=script&lang=js"
export * from "./realName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d25fe3b",
  null
  
)

export default component.exports